enum ScheduleType {
    Fixed = "FIXED",
    Dynamic = "DYNAMIC"
}
export default ScheduleType